import { createContext, useContext } from "react";

type CookieLocation = {
  countryCode?: string;
  regionCode?: string;
};

const CookieLocationContext = createContext<CookieLocation>({});

export function CookieLocationProvider({
  countryCode,
  regionCode,
  children,
}: CookieLocation & { children: React.ReactNode }) {
  return (
    <CookieLocationContext.Provider value={{ countryCode, regionCode }}>
      {children}
    </CookieLocationContext.Provider>
  );
}

export function useCookieLocation() {
  return useContext(CookieLocationContext);
}
